//@ts-ignore
import React, { useEffect, useState } from "react";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { Box, Container } from "@mui/material";

//@ts-ignore
import styles from "./App.module.scss";
import { logoutUser, userDetail } from "@store/auth";
import { getCookie } from "../utils/cookie";
//@ts-ignore
import { googleLogout } from "@react-oauth/google";

import Login from "../applications/dashboard/pages/Login/Login";
import Landing from "../applications/dashboard/pages/Landing/Landing";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router";
import DashboardApp from "src/DashboardApp/DashboardApp";
import DashboardComponent from "src/DashboardApp/components/DashboardComponent";

import { customPages as GiftWrapperCustomPages } from "../applications/gift-wrapper-management/custom-pages";
import { customPages as AssetManagementCustomPages } from "../applications/assets-management/custom-pages";
import { customPages as CategoryManagementCustomPages } from "../applications/category-management/custom-pages";
import { customPages as MerchantManagementCustomPages } from "../applications/merchant-management/custom-pages";
import { customPages as LabelManagementCustomPages } from "../applications/label-management/custom-pages";
import { customPages as SkuManagementCustomPages } from "../applications/sku-management/custom-pages";
import { customPages as FlashSaleCustomPages } from "../applications/flash-sale-management/custom-pages";
import { customPages as RecommendationCustomPages } from "../applications/recommendation-management/custom-pages";
import { customPages as BulkPurchaseCustomPages } from "../applications/bulk-purchase-management/custom-pages";

import { CustomPage } from "src/DashboardApp/types";
// @ts-ignore
import apiConfig from "../axiosConfig";
import { utils } from "../utils/dashboard-builder-utils";

const customPages = [...([...GiftWrapperCustomPages, ...AssetManagementCustomPages, ...CategoryManagementCustomPages, ...MerchantManagementCustomPages, ...LabelManagementCustomPages, ...SkuManagementCustomPages, ...FlashSaleCustomPages, ...RecommendationCustomPages, ...BulkPurchaseCustomPages] as CustomPage[])];

function DashboardAppMain() {
	const dispatch = useDispatch();
	const { name } = useSelector((state) => (state as any).auth);

	const onLogOut = () => {
		googleLogout();
		//@ts-ignore
		dispatch(logoutUser());
	};

	const openReleaseNotes = () => {
		window.open("", "_blank");
	};
	return (
		<>
			<DashboardApp
				axios={apiConfig}
				utils={utils}
				extendedComponents={
					{
						// CustomAlert: { name: "Custom Alert", icon: "warning", component: DashboardComponent, schema: [], allowedChild: [] },
					}
				}
				env={{
					DB_ADMIN_URL_CTRL_PREFIX: "/admin/dashboard",
				}}
				sidePanelExt={[
					{ title: "What's New", icon: "fiber_new", onClick: () => openReleaseNotes() },
					{ title: name, icon: "account_circle", onClick: () => {} },
					{ title: "Logout", icon: "logout", onClick: () => onLogOut() },
					{ title: "Settings", icon: "settings", path: "/admin" },
				]}
				customPages={customPages}
			/>
		</>
	);
}

function App() {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);

	const dispatch = useDispatch();
	const { isAuthenticated } = useSelector((state) => (state as any).auth);

	useEffect(() => {
		const token = getCookie("loginToken");
		if (token) {
			//@ts-ignore
			dispatch(userDetail()).then(() => {
				setIsLoading(false);
			});
		} else setIsLoading(false);
	}, [dispatch]);

	useEffect(() => {
		if (!isLoading) {
			if (!isAuthenticated) {
				navigate("/login");
			}
		}
	}, [isLoading, isAuthenticated, navigate]);

	return (
		<>
			{!isLoading && (
				<Box className={styles.App} style={{ padding: 0 }}>
					{
						//@ts-ignore
						<Routes>
							{
								//@ts-ignore
								<Route path="/*" element={<DashboardAppMain />} />
							}
							{
								//@ts-ignore
								<Route path="/login" element={<Login />} />
							}
						</Routes>
					}
				</Box>
			)}
		</>
	);
}

export default App;
